import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function MarketingLayout() {
  return (
    <div className="min-h-screen bg-[#0f0f11]">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export function PageHero({ eyebrow, title, subtitle, image, children }) {
  return (
    <section className="relative pt-28 sm:pt-36 pb-14 sm:pb-20 overflow-hidden grain" data-testid="page-hero">
      {image && (
        <div className="absolute inset-0 -z-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f11] via-[#0f0f11]/70 to-[#0f0f11]/40" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-6 z-10">
        {eyebrow && <div className="font-heading uppercase tracking-[0.25em] text-[#ff7a1a] text-xs sm:text-sm mb-3 fade-up">{eyebrow}</div>}
        <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl uppercase leading-[0.85] text-white fade-up">{title}</h1>
        {subtitle && <p className="mt-5 max-w-2xl text-[#8a8d91] text-base sm:text-lg font-body fade-up">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
